import React, { useReducer } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { AlertContext } from './AlertContext'
import { REMOVE_ALERT, REMOVE_ALL_ALERTS, SET_ALERT } from './constants'
import {
  AlertCenterProviderProps,
  Alert as IAlert,
  AlertItem as IAlertItem,
} from './types'

interface IAction {
  type: string
  payload?: IAlertItem
}

function reducer(state: IAlertItem[], action: IAction) {
  switch (action.type) {
    case SET_ALERT:
      return [...state, { ...action.payload }]
    case REMOVE_ALERT:
      return state.filter(
        alert => action.payload && alert.id !== action.payload.id
      )
    case REMOVE_ALL_ALERTS:
      return []
    default:
      throw new Error()
  }
}

export const AlertCenterProvider = ({ children }: AlertCenterProviderProps) => {
  const [alerts, dispatch] = useReducer(reducer, [])

  const setAlert = ({
    title,
    description,
    isClosable,
    status,
    direction,
    showIcon,
    id = uuidv4(),
  }: IAlert) => {
    dispatch({
      type: SET_ALERT,
      payload: {
        title,
        description,
        isClosable,
        status,
        direction,
        showIcon,
        id,
      },
    })
    return { id }
  }

  const removeAlert = (id: string) => {
    dispatch({
      type: REMOVE_ALERT,
      payload: { id },
    })
  }

  const removeAllAlerts = () => {
    dispatch({
      type: REMOVE_ALL_ALERTS,
    })
  }

  return (
    <AlertContext.Provider
      value={{
        alerts,
        setAlert,
        removeAllAlerts,
        removeAlert,
      }}
    >
      {children}
    </AlertContext.Provider>
  )
}
